import Game18 from 'images/games/2048-blitz/game18.png'
import Game16 from 'images/games/21-gold/game16.png'
import Game4 from 'images/games/8-ball-strike/game4.png'
import Game12 from 'images/games/bingo-bliss/game12.png'
import Game2 from 'images/games/bingo-clash/game2.png'
import Game3 from 'images/games/bingo-tour/game3.png'
import Game7 from 'images/games/blockolot/game7.png'
import Game8 from 'images/games/bubble-buzz/game8.png'
import Game9 from 'images/games/cash-pool/game9.png'
import Game21 from 'images/games/dominoes/game21.png'
import Game20 from 'images/games/dunk-shot/game20.png'
import Game14 from 'images/games/match-n-flip/game14.png'
import Game15 from 'images/games/playsolitaireonline/game15.png'
import Game6 from 'images/games/pocket7games/game6.png'
import Game19 from 'images/games/pool-clash/game19.png'
import Game1 from 'images/games/solitaire-clash/game1.png'
import Game10 from 'images/games/solitaire-infinite/game10.png'
import Game11 from 'images/games/solitaire-slam/game11.png'
import Game5 from 'images/games/solitaire-venture/game5.png'
import Game17 from 'images/games/tile-blitz/game17.png'
import { StaticImageData } from 'next/image'
import { GameRatings, GamesNames, GameType } from './const'
import { GamesRoutes } from './route'
import { GamesStore } from './store'
import { GameEntity } from './types'

export const GameLogos: Record<GameType, StaticImageData> = {
  [GameType.SolitaireClash]: Game1,
  [GameType.BingoClash]: Game2,
  [GameType.BingoTour]: Game3,
  [GameType.EightBallStrike]: Game4,
  [GameType.SolitaireVenture]: Game5,
  [GameType.Pocket7Games]: Game6,
  [GameType.Blockolot]: Game7,
  [GameType.BubbleBuzz]: Game8,
  [GameType.CashPool]: Game9,
  [GameType.SolitaireInfinite]: Game10,
  [GameType.SolitaireSlam]: Game11,
  [GameType.BingoBliss]: Game12,
  [GameType.MatchNFlip]: Game14,
  [GameType.PlaySolitaireOnline]: Game15,
  [GameType.TwentyOneGold]: Game16,
  [GameType.TileBlitz]: Game17,
  [GameType.NumbersBlitz]: Game18,
  [GameType.PoolClash]: Game19,
  [GameType.DunkShot]: Game20,
  [GameType.Dominoes]: Game21,
}

const generateGameEntity = (key: GameType, entity?: Partial<GameEntity>) => {
  return {
    key,
    route: GamesRoutes[key],
    title: GamesNames[key],
    store: GamesStore[key],
    logo: GameLogos[key],
    ...GameRatings[key],
    ...entity,
  } as GameEntity
}

export const SolitaireClashEntity = generateGameEntity(GameType.SolitaireClash)

export const BingoClashEntity = generateGameEntity(GameType.BingoClash)

export const BingoTourEntity = generateGameEntity(GameType.BingoTour)

export const EightBallStrikeEntity = generateGameEntity(GameType.EightBallStrike)

export const SolitaireVentureEntity = generateGameEntity(GameType.SolitaireVenture)

export const Pocket7GamesEntity = generateGameEntity(GameType.Pocket7Games)

export const BlockolotEntity = generateGameEntity(GameType.Blockolot)

export const BubbleBuzzEntity = generateGameEntity(GameType.BubbleBuzz)

export const CashPoolEntity = generateGameEntity(GameType.CashPool)

export const SolitaireInfiniteEntity = generateGameEntity(GameType.SolitaireInfinite)

export const SolitaireSlamEntity = generateGameEntity(GameType.SolitaireSlam)

export const BingoBlissEntity = generateGameEntity(GameType.BingoBliss)

export const MatchNFlipEntity = generateGameEntity(GameType.MatchNFlip)

export const PlaySolitaireOnlineEntity = generateGameEntity(GameType.PlaySolitaireOnline)

export const TwentyOneGoldEntity = generateGameEntity(GameType.TwentyOneGold)

export const TileBlitzEntity = generateGameEntity(GameType.TileBlitz)

export const NumbersBlitzEntity = generateGameEntity(GameType.NumbersBlitz)

export const PoolClashEntity = generateGameEntity(GameType.PoolClash)

export const DunkShotEntity = generateGameEntity(GameType.DunkShot)

export const DominoesEntity = generateGameEntity(GameType.Dominoes)
